(function () {
  "use strict";
  if (window.InShapeUnboxingQA) return;
  var API_ORIGIN = "https://inshape-first-purchase-survey.mftwice.chatgpt.site";
  var QA_THEME = "188283125871";
  var QA_KEY = "inshape-unboxing-qa-v1:" + API_ORIGIN + ":" + QA_THEME;
  var routes = ["experience-config", "offers", "journey", "unboxing-complete", "unboxing-response", "unboxing-handoff", "unboxing-reward", "unboxing-apply"];
  var events = ["experience_opened", "reward_revealed", "quiz_started", "answered_tank_feel", "answered_feel_detail", "answered_problem_to_solve", "offer_viewed", "pack_3_clicked", "pack_5_clicked", "product_viewed", "variant_selected", "cart_add_clicked", "cart_discount_applied", "checkout_clicked"];
  var sources = ["hang_tag", "direct", "invitation_email", "receipt_email", "recovery_email"];
  var uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/;
  var queue = null;
  var queueKey = "";
  var drainPromise = null;
  var drainRequested = false;
  var receipts = Object.create(null);

  function removeQA() {
    try { window.sessionStorage.removeItem(QA_KEY); } catch (_) {}
  }
  function claims(token) {
    try {
      if (typeof token !== "string" || token.length > 1500 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token)) return null;
      var encoded = token.split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
      var value = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "=")));
      var expiry = Date.parse(value.expiresAt);
      if (value.purpose !== "qa" || typeof value.id !== "string" || value.id.slice(0, QA_THEME.length + 1) !== QA_THEME + ":" || !uuid.test(value.id.slice(QA_THEME.length + 1)) || typeof value.expiresAt !== "string" || !/^\d{4}-\d{2}-\d{2}T[0-9:.]+Z$/.test(value.expiresAt) || !Number.isFinite(expiry) || expiry <= Date.now() || expiry - Date.now() > 31 * 60000) return null;
      return value;
    } catch (_) { return null; }
  }
  function devTheme() {
    var theme = window.Shopify && window.Shopify.theme;
    return Boolean(theme && String(theme.id) === QA_THEME && ["development", "unpublished"].indexOf(theme.role) !== -1);
  }
  function currentToken() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(QA_KEY) || "null");
      if (stored && claims(stored.token)) return stored.token;
    } catch (_) {}
    removeQA();
    return "";
  }
  function capture() {
    try {
      var url = new URL(window.location.href);
      var fragment = new URLSearchParams(url.hash.slice(1));
      if (!fragment.has("qa_token")) return;
      var token = fragment.get("qa_token") || "";
      fragment.delete("qa_token");
      url.hash = fragment.toString();
      window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
      var theme = window.Shopify && window.Shopify.theme;
      var requestedTheme = url.searchParams.get("preview_theme_id");
      if ((theme && !devTheme()) || (requestedTheme && requestedTheme !== QA_THEME) || !claims(token)) { removeQA(); return; }
      window.sessionStorage.setItem(QA_KEY, JSON.stringify({ token: token }));
    } catch (_) { removeQA(); }
  }
  function headers(target, initial) {
    var output = Object.assign({}, initial || {});
    Object.keys(output).forEach(function (key) { if (key.toLowerCase() === "x-inshape-qa") delete output[key]; });
    try {
      var url = new URL(target);
      if (url.origin !== API_ORIGIN || routes.indexOf(url.pathname.slice(5)) === -1 || url.pathname.indexOf("/api/") !== 0 || !devTheme()) return output;
      var token = currentToken();
      if (token) output["X-InShape-QA"] = token;
    } catch (_) {}
    return output;
  }
  function clean(body) {
    if (!body || !uuid.test(body.visit || "") || ["cards", "wheel", "scratch"].indexOf(body.variant) === -1 || events.indexOf(body.event) === -1 || sources.indexOf(body.entrySource) === -1) return null;
    return { visit: body.visit, variant: body.variant, event: body.event, entrySource: body.entrySource };
  }
  function eventKey(body) { return body.visit + ":" + body.entrySource + ":" + body.event; }
  function pending() {
    if (queue) return queue;
    var theme = window.Shopify && window.Shopify.theme;
    queueKey = "inshape-unboxing-journey-queue-v1:" + API_ORIGIN + ":" + String(theme && theme.id || "unknown");
    queue = [];
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(queueKey) || "[]");
      if (Array.isArray(saved)) saved.slice(0, 32).forEach(function (item) {
        var body = clean(item && item.body);
        if (body && Number.isFinite(item.createdAt) && item.createdAt <= Date.now() && Date.now() - item.createdAt < 5 * 60000 && !queue.some(function (entry) { return eventKey(entry.body) === eventKey(body); })) queue.push({ body: body, createdAt: item.createdAt, requiresQA: item.requiresQA === true });
      });
    } catch (_) {}
    return queue;
  }
  function saveQueue() {
    try {
      if (queue.length) window.sessionStorage.setItem(queueKey, JSON.stringify(queue));
      else window.sessionStorage.removeItem(queueKey);
    } catch (_) {}
  }
  function settle(key, successful) {
    (receipts[key] || []).forEach(function (resolve) { resolve(successful); });
    delete receipts[key];
  }
  function drain() {
    if (drainPromise) { drainRequested = true; return drainPromise; }
    pending();
    drainPromise = (async function () {
      while (queue.length) {
        drainRequested = false;
        var item = queue[0];
        var key = eventKey(item.body);
        if (item.requiresQA && (!devTheme() || !currentToken())) { queue.shift(); saveQueue(); settle(key, false); continue; }
        if (Date.now() - item.createdAt >= 5 * 60000) { queue.shift(); saveQueue(); settle(key, false); continue; }
        var controller = typeof AbortController === "function" ? new AbortController() : null;
        var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 2500);
        var successful = false;
        try {
          var target = API_ORIGIN + "/api/journey";
          var response = await fetch(target, { method: "POST", credentials: "omit", headers: headers(target, { "Content-Type": "application/json" }), body: JSON.stringify(item.body), referrerPolicy: "no-referrer", keepalive: true, signal: controller ? controller.signal : undefined });
          successful = response.ok;
        } catch (_) {} finally { window.clearTimeout(timer); }
        if (!successful) { drainRequested = false; settle(key, false); return false; }
        queue.shift(); saveQueue(); settle(key, true);
      }
      return true;
    })().finally(function () {
      var restart = queue.length && drainRequested;
      drainRequested = false; drainPromise = null;
      if (restart) drain();
    });
    return drainPromise;
  }
  function postJourney(target, input) {
    var body = clean(input);
    if (target !== API_ORIGIN + "/api/journey" || !body || (devTheme() && !currentToken())) return Promise.resolve(false);
    pending();
    var key = eventKey(body);
    if (!queue.some(function (item) { return eventKey(item.body) === key; })) {
      if (queue.length >= 32) return Promise.resolve(false);
      queue.push({ body: body, createdAt: Date.now(), requiresQA: devTheme() }); saveQueue();
    }
    var receipt = new Promise(function (resolve) { (receipts[key] || (receipts[key] = [])).push(resolve); });
    drain();
    return receipt;
  }
  function flushJourney(milliseconds) {
    var timeout = Math.max(0, Math.min(Number(milliseconds) || 750, 750));
    return new Promise(function (resolve) {
      var timer = window.setTimeout(function () { resolve(false); }, timeout);
      drain().then(function (successful) { window.clearTimeout(timer); resolve(successful); });
    });
  }
  capture();
  window.InShapeUnboxingQA = { headers: headers, active: function () { return devTheme() && Boolean(currentToken()); }, clear: removeQA, postJourney: postJourney, flushJourney: flushJourney };
})();
